import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { marionIAConfig } from "./data";

export default function MarionIAPage() {
  return <CityPageTemplate config={marionIAConfig} />;
}